import { action } from 'satcheljs';

export const onNudgeIsEnableSaved = action('ON_NUDGE_IS_ENABLE_SAVED');
